import React from 'react'
import PropTypes from 'prop-types'

export default function Loading({ isLoading, pastDelay, error }) {
  if (isLoading && pastDelay) {
    return <p></p>
  } else if (error && !isLoading) {
    return <p></p>
  } else {
    return null
  }
}

Loading.propTypes = {
  isLoading: PropTypes.any,
  pastDelay: PropTypes.any,
  error: PropTypes.any
}
